import React, { Component } from 'react'
import {css,style} from 'glamor'
import Globals from './../Globals'

import Button from './Button'
import Text from './Text'

const styles = {
  hero:css({
    "width": "100%"
  }),
    header_nav_link:css({
        "textDecoration": "none",
        "fontFamily": Globals.fonts.regular,
        "fontSize": "18px",
        "lineHeight": "1.67",
        "textAlign": "right",
        "marginRight": "10px",
        "paddingLeft": "20px",
        "paddingRight": "20px",
        cursor: 'pointer',
        "padding": "5px 20px",
        "borderRadius": "20px",
        display: 'inline-block',
        "border": "solid 2px " + Globals.colors.red,
        background: Globals.colors.red,
        color: Globals.colors.white,
        '&:hover':{
            "border": "solid 2px " + Globals.colors.green,
            background: Globals.colors.green,
            color: Globals.colors.white
        },
    }),
  container:css({
    width: '90%',
    "height": "1300px",
    paddingTop: 60,
    margin: '0 auto',
    '@media(min-width: 768px)':{
      paddingTop: 60,
      maxWidth: 1024,
      "height": "770px"
    },
    '@media(min-width: 1024px)':{
      paddingTop: 103,
      maxWidth: 1024,
      "height": "600px"
    }
  }),
    header_nav: css({
        "marginLeft": "10%"
    }),
  main: css({
    "position": "relative",
    "top": "45%",
    "transform": "translateY(-50%)",
    "MozTransform": "translateY(-50%)",
    "WebkitTransform": "translateY(-50%)",
    "MsTransform": "translateY(-50%)",
    "OTransform": "translateY(-50%)", 
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-around', 
    flexFlow: 'column wrap', 
    alignItems: 'center',
    alignContent: 'flex-start',
    '@media(min-width: 768px)':{
      flexFlow: 'row wrap',
      alignItems: 'stretch'
    },
    '> li':{
      flex: 1,
      maxWidth: 241,
      padding: '10px 0'
    }
  }),
  src: css({
    width: 241,
    height: 250,
    backgroundSize: 'contain',
    display: 'block',
    margin: '0 auto',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    '@media(min-width:1024px)':{
      width: 241
    },
    '@media(min-width:1100px)':{
      width: 241
    }
  }),
  infos: css({
    position: 'absolute',
    bottom: 30,
    left: 30
  })
};

const content = {
  id: 'reports',
  title: {
    type: 'h3',
    header: 'Reports',
    align: 'center',
    color: [Globals.colors.white,Globals.colors.white]
  },
  role: 'link'
};

const navItens = [
    {section: 'Specification', link:'https://firebasestorage.googleapis.com/v0/b/pandoratestarea.appspot.com/o/spec.pdf?alt=media&token=c5b75dcb-b9fd-49c3-bab0-2136f242310c'},
    {section: 'Analysis', link:'https://firebasestorage.googleapis.com/v0/b/pandoratestarea.appspot.com/o/Analysis_Report.docx.pdf?alt=media&token=215e719b-32db-46fc-9e65-9e36e7d35474'},
    {section: 'High Level Design', link:'https://firebasestorage.googleapis.com/v0/b/pandoratestarea.appspot.com/o/high_level_design.pdf?alt=media&token=e5be6803-17d7-4efc-a59c-8adc8660d6e3'},
    {section: 'Low Level Design', link:'https://firebasestorage.googleapis.com/v0/b/pandoratestarea.appspot.com/o/low_level_design.pdf?alt=media&token=52e9adec-e767-4dde-abe6-c46dbe429bbc'},
    {section: 'Final', link:'https://firebasestorage.googleapis.com/v0/b/pandoratestarea.appspot.com/o/Final%20Report.pdf?alt=media&token=35080ba0-aee4-4d37-81b4-62f38f233c5e'}
];


export default class Construtores extends Component {

    render(){
        return (
        <div {...styles.hero} role={content.link} id={content.id}>
          <div {...styles.container}>
            <Text type={content.title.type} label={content.title.header} align={content.title.align} width={content.title.width} margin={content.title.margin} color={content.title.color} />
            <Text type={'normal'} label={content.title.description} align={content.title.align}/>
              <ul {...styles.header_nav}>
                  {navItens.map((navItem, index) => {
                      return (
                          <li key={index} {...styles.header_nav_link}>
                              <a onClick={this.goToAddress.bind(this, navItem.link)}>{navItem.section}</a>
                          </li>
                      )
                  })}
              </ul>
          </div>
        </div>
        )
    }

    goToAddress(loc) {
        window.location.href = loc;
    }

}


// WEBPACK FOOTER //
// ./src/componentes/Reports.js